import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramLogo, FacebookLogo, WhatsappLogo, EnvelopeSimple, MapPin, Phone } from '@phosphor-icons/react';

const Footer = () => {
  return (
    <footer className="bg-secondary text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <img 
              src="/logo.png" 
              alt="Luster Adorn" 
              className="h-10 w-auto mb-4 brightness-0 invert"
            />
            <p className="font-body text-gray-400 text-sm leading-relaxed mb-6">
              Discover exquisite imitation jewelry that celebrates elegance and craftsmanship. 
              Premium quality pieces at affordable prices.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.instagram.com/luster.adorn?igsh=ejEwd2F5YXpvZXZr" 
                target="_blank" 
                rel="noopener noreferrer"
                data-testid="social-instagram"
                className="text-gray-400 hover:text-primary transition-colors"
              >
                <InstagramLogo size={24} />
              </a>
              <a 
                href="https://www.facebook.com/share/17TAD2EcNs/" 
                target="_blank" 
                rel="noopener noreferrer"
                data-testid="social-facebook"
                className="text-gray-400 hover:text-primary transition-colors"
              >
                <FacebookLogo size={24} />
              </a>
              <a 
                href="https://wa.me/919421147643" 
                target="_blank" 
                rel="noopener noreferrer"
                data-testid="social-whatsapp"
                className="text-gray-400 hover:text-primary transition-colors"
              >
                <WhatsappLogo size={24} />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="font-display text-lg mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/shop" className="font-body text-sm text-gray-400 hover:text-primary transition-colors">
                  Shop All
                </Link>
              </li>
              <li>
                <Link to="/about" className="font-body text-sm text-gray-400 hover:text-primary transition-colors">
                  Our Story
                </Link>
              </li>
              <li>
                <Link to="/contact" className="font-body text-sm text-gray-400 hover:text-primary transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="font-body text-sm text-gray-400 hover:text-primary transition-colors">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/cart" className="font-body text-sm text-gray-400 hover:text-primary transition-colors">
                  Shopping Cart
                </Link>
              </li>
              {/* <li>
                <Link to="/track-order" className="font-body text-sm text-gray-400 hover:text-primary transition-colors">
                  Track Order
                </Link>
              </li> */}
            </ul>
          </div>
          
          {/* Categories */}
          <div>
            <h3 className="font-display text-lg mb-4">Categories</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/shop" className="font-body text-sm text-gray-400 hover:text-primary transition-colors">
                  Necklaces
                </Link>
              </li>
              <li>
                <Link to="/shop" className="font-body text-sm text-gray-400 hover:text-primary transition-colors">
                  Earrings
                </Link>
              </li>
              <li>
                <Link to="/shop" className="font-body text-sm text-gray-400 hover:text-primary transition-colors">
                  Bracelets
                </Link>
              </li>
              <li>
                <Link to="/shop" className="font-body text-sm text-gray-400 hover:text-primary transition-colors">
                  Rings
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h3 className="font-display text-lg mb-4">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-primary flex-shrink-0 mt-1" />
                <span className="font-body text-sm text-gray-400">
                  Maharashtra, India
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={20} className="text-primary flex-shrink-0" />
                <a href="tel:+919421147643" className="font-body text-sm text-gray-400 hover:text-primary transition-colors">
                  +91 94211 47643
                </a>
              </li>
              <li className="flex items-center gap-3">
                <EnvelopeSimple size={20} className="text-primary flex-shrink-0" />
                <a href="mailto:hello@lusteradorn.com" className="font-body text-sm text-gray-400 hover:text-primary transition-colors">
                  hello@lusteradorn.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-body text-sm text-gray-500">
              © {new Date().getFullYear()} Luster Adorn. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy-policy" className="font-body text-xs text-gray-500 hover:text-gray-400 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="font-body text-xs text-gray-500 hover:text-gray-400 transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
